import React, {Component, Fragment} from 'react';
import {
    Datagrid,
    List,
    NumberField,
    TextField,
} from 'react-admin';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

const UserTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>VN server offering</span>;
};


class VnNodeList extends Component {
    render() {
        const props = this.props;
        return (
            <Fragment>
                <List
                    title={<UserTitle />} {...props}
                    bulkActions={false}
                    sort={{ field: 'Threads', order: 'DESC' }}
                    exporter={false}
                >
                    <Datagrid rowClick="show">
                        <TextField
                            source="PID"
                            label={"Item Number"}/>
                        <TextField
                            source="Description"
                            label={"Item Description"}/>
                        <NumberField
                            source="Sockets"
                            label={"Sockets"}/>
                        <NumberField
                            source="Threads"
                            label={"Threads [vCPU]"}/>
                        <NumberField
                            source="BaseFrequency"
                            label={"Base Frequency [GHz]"}/>
                    </Datagrid>
                </List>
            </Fragment>
        );
    }
}

export default connect(
    undefined,
    { push }
)(VnNodeList);